/**
 * Homepage scroll reveal — only animates when scrolling down into view.
 * Resets when leaving the viewport so a later downward re-entry can play again.
 * Skips first banner + subscribe/newsletter sections.
 */
(() => {
  const run = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const main = document.getElementById('MainContent');
    if (!main) return;

    const sections = Array.from(main.children).filter((el) =>
      el.classList.contains('shopify-section')
    );
    if (sections.length < 2) return;

    const isExcluded = (section) => {
      if (section.querySelector('.email-signup-block, .email-signup__form')) {
        const text = (section.textContent || '').toLowerCase();
        if (text.includes('subscribe') || text.includes('email')) return true;
      }
      return (section.textContent || '').toLowerCase().includes('subscribe to our emails');
    };

    const targets = sections.slice(1).filter((section) => !isExcluded(section));

    targets.forEach((section) => {
      section.classList.add('scroll-reveal');
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('scroll-reveal--visible'));
      return;
    }

    let lastScrollY = window.scrollY || window.pageYOffset;
    let scrollingDown = true;

    window.addEventListener(
      'scroll',
      () => {
        const y = window.scrollY || window.pageYOffset;
        if (y !== lastScrollY) {
          scrollingDown = y > lastScrollY;
          lastScrollY = y;
        }
      },
      { passive: true }
    );

    const setVisibleInstant = (el, visible) => {
      el.classList.add('scroll-reveal--no-motion');
      el.classList.toggle('scroll-reveal--visible', visible);
      // Restore transitions on next frame for future downward enters.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.classList.remove('scroll-reveal--no-motion');
        });
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;

          if (entry.isIntersecting) {
            if (scrollingDown) {
              el.classList.add('scroll-reveal--visible');
            } else {
              // Entering while scrolling up: show without animation.
              setVisibleInstant(el, true);
            }
            return;
          }

          // Left the viewport — reset so the next downward enter can animate.
          setVisibleInstant(el, false);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    targets.forEach((section) => observer.observe(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
